const captureErrorInSentry = (error) => {
  const newError = {
    ...error,
    skip: true,
  };
  throw newError;
};

export default captureErrorInSentry;
